import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  transition: color 0.2s ease-out;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Styles for normal text elements
import { css } from 'styled-components';
import { NIGHTINGALE_BLACK, SENSATION_WHITE } from '../../colors';
import { FONT_FAMILY_BASE } from '../../constants';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
export var baseTextStyle = "\n  font-family: " + FONT_FAMILY_BASE + ";\n  font-weight: 400;\n  margin: 0;\n  letter-spacing: 0;\n  font-style: normal;\n  font-stretch: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n";
export var baseTypographyStyle = css(_templateObject(), function (_ref) {
  var color = _ref.color,
      negative = _ref.negative,
      inverse = _ref.inverse;
  return color || (negative || inverse ? SENSATION_WHITE : NIGHTINGALE_BLACK);
}, baseTextStyle, baseSelectionStyle, baseHighlightStyle);